import { Box } from '@mui/material';
import { SelectedFilterPill } from '../selected-filter-pill';
import { ASSET, SEPARATOR, initialFilters } from '../../config/config';
import { sitesTypes, assetTypes } from './variables';
import { useFormContext } from 'react-hook-form';
import { useFilterSites } from '../../context/sitesContext';
import React from 'react';

const SelectedFiltersList = ({
  applyFiltersHandler,
  isLoading,
  disabled,
}: {
  applyFiltersHandler: any;
  isLoading: boolean;
  disabled?: boolean;
}) => {
  const { watch, setValue } = useFormContext();

  const { sites } = useFilterSites();
  const appliedFilters = watch('filters') as typeof initialFilters;
  if (!appliedFilters || isLoading) {
    return <div>loading...</div>;
  }
  const lengthOfSelectedAssetTypes = appliedFilters?.assetTypes?.length;
  const lengthOfSelectedSitesTypes = appliedFilters?.sitesTypes?.length;
  const selectedAssets = appliedFilters?.selectedItems?.filter((item) => item.includes(ASSET));

  const selectedSites = appliedFilters?.selectedItems?.filter(
    (item) => item && item.substring(0, 4) === 'site'
  );

  const assetTypesInitialLength = initialFilters.assetTypes.length;
  const sitesTypesInitialLength = initialFilters.sitesTypes.length;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        marginBottom: '10px',
      }}
    >
      {!appliedFilters?.selectedItems?.filter((item) => item.includes('site')).length && (
        <SelectedFilterPill
          disabled={disabled}
          title={'Sites: 0'}
          onDelete={() =>
            applyFiltersHandler({
              ...initialFilters,
              selectedItems: [...sites, ...selectedAssets],
            })
          }
        />
      )}
      {lengthOfSelectedAssetTypes > 2 && lengthOfSelectedAssetTypes < assetTypesInitialLength && (
        <SelectedFilterPill
          disabled={disabled}
          title={`Asset Type: ${lengthOfSelectedAssetTypes}`}
          onDelete={() => {
            setValue('filters', { ...appliedFilters, assetTypes: initialFilters.assetTypes });
          }}
        />
      )}
      {lengthOfSelectedAssetTypes < 3 &&
        appliedFilters?.assetTypes?.map((assetType) => {
          // @ts-ignore
          let pillTitle = assetTypes[assetType] ?? assetType;
          const newAssetState = appliedFilters.assetTypes.filter((item) => item !== assetType);
          return (
            <SelectedFilterPill
              disabled={disabled}
              key={assetType}
              title={pillTitle}
              onDelete={() => {
                setValue('filters', {
                  ...appliedFilters,
                  assetTypes:
                    newAssetState.length === 0 ? initialFilters.assetTypes : newAssetState,
                });
              }}
            />
          );
        })}

      {lengthOfSelectedSitesTypes > 2 && lengthOfSelectedSitesTypes < sitesTypesInitialLength && (
        <SelectedFilterPill
          disabled={disabled}
          title={`Site Type: ${lengthOfSelectedSitesTypes}`}
          onDelete={() => {
            setValue('filters', {
              ...appliedFilters,
              sitesTypes: initialFilters.sitesTypes,
            });
          }}
        />
      )}
      {lengthOfSelectedSitesTypes < 3 &&
        appliedFilters?.sitesTypes?.map((siteType) => {
          // @ts-ignore
          let pillTitle = sitesTypes[siteType] ?? siteType;
          const newSitesState = appliedFilters.sitesTypes.filter((item) => item !== siteType);
          return (
            <SelectedFilterPill
              disabled={disabled}
              key={siteType}
              title={pillTitle}
              onDelete={() => {
                setValue('filters', {
                  ...appliedFilters,
                  sitesTypes:
                    newSitesState.length === 0 ? initialFilters.sitesTypes : newSitesState,
                });
              }}
            />
          );
        })}

      {selectedSites?.length !== sites?.length ? (
        selectedSites?.length > 2 ? (
          <SelectedFilterPill
            disabled={disabled}
            title={`Site Name: ${selectedSites?.length}`}
            onDelete={() => {
              setValue('filters', {
                ...appliedFilters,
                selectedItems: selectedAssets,
              });
            }}
          />
        ) : (
          selectedSites.map((site) => {
            const splitedSite = site.split(SEPARATOR);
            const newState = appliedFilters.selectedItems.filter((item) => item !== site);
            return (
              <SelectedFilterPill
                disabled={disabled}
                key={site}
                title={splitedSite[1]}
                onDelete={() => {
                  setValue('filters', {
                    ...appliedFilters,
                    selectedItems: newState,
                  });
                }}
              />
            );
          })
        )
      ) : (
        <></>
      )}

      {selectedAssets?.length > 2 ? (
        <SelectedFilterPill
          disabled={disabled}
          title={`Asset Name: ${selectedAssets?.length}`}
          onDelete={() => {
            setValue('filters', {
              ...appliedFilters,
              selectedItems: selectedSites,
            });
          }}
        />
      ) : (
        selectedAssets?.map((asset) => {
          const splitedAsset = asset.split(SEPARATOR);
          const newState = appliedFilters?.selectedItems?.filter((item) => item !== asset);
          return (
            <SelectedFilterPill
              disabled={disabled}
              key={asset}
              title={splitedAsset[1]}
              onDelete={() => {
                setValue('filters', {
                  ...appliedFilters,
                  selectedItems: newState,
                });
              }}
            />
          );
        })
      )}
    </Box>
  );
};

export const MemoSelectedFiltersList = React.memo(SelectedFiltersList);
